import Helpers from '@helpers';

const initCompare = () => {
    //Helpers.Utils.clearCookie('Compare');
    $('.new-compare').click(() => {
        const DivDarkScreen = $('.modal-overlay');

        DivDarkScreen.fadeIn();
        $('.compare-modal').fadeIn();
    });

    document.addEventListener("DOMContentLoaded", function() {

        if (document.getElementById('divCompare').style.display == "block") {
            if (window.innerWidth < 992) {
                $('.compare-button-responsive').css('display', 'flex');
                $('.filter-button-responsive').css('display', 'none');
            }
        }
    });


    $('.compare-checkbox').click(function() {
        let items = [];
        const currentID = $(this).attr('productid');
        let ids = Helpers.Utils.getCookie('Compare');
        if (ids) {
            items = ids.split(',');
            const index = items.indexOf(currentID);
            if (index > -1) {
                items.splice(index, 1);
                $(this).css('display', '');
            } else {
                var maxNum = 2;
                if (window.innerWidth < 992) {
                    maxNum = 1;
                }
                if (items.length > maxNum) {
                    maxNum += 1;
                    alert( 'حداکثر ' + maxNum + ' کالا می‌توانید برای مقایسه انتخاب کنید.');
                    $(this).prop('checked', false);
                } else {
                    items.push(currentID);
                    $(this).css('display', 'block');
                }
            }
        } else {
            items.push(currentID);
            $(this).css('display', 'block');
        }

        ids = '';
        for (const item of items) {
            ids += item + ',';
        }
        if (ids) {
            ids = ids.substring(0, ids.length - 1);
        }
        Helpers.Utils.setCookie('Compare', ids, 0);

        if (items.length === 0) {
            $('.compare-wrapper').slideUp();
            $('.compare-button-responsive').css('display', 'none');
            $('.filter-button-responsive').css('display', 'block');
            return;
        }

        Helpers.ApiHelper.getProducts(ids).then(data => {
            let sb = '';
            for (const item of data.items) {
                var imgSrc = (item.image).replace('[small]', '[large]');
                sb += '<a class=\'compare-list-item\' href=\'';
                sb += item.link + '\'>';

                sb += '<img class=\'compare-wrapper-img\' src=\'' + imgSrc + '\' />';
                sb += '<div class=\'compare-list-item-title-wrapper\'>';
                sb += '<span class=\'compare-list-item-tilte\'>' + item.title + '</span>';
                //sb += '<p>3,910,000</P>';
                //sb += '<button class=\'btn btn-red\'>مشاهده محصول</button>';
                sb += '</div>';
                sb += '</a>';
            }
            sb += '</ul>';
            $('.compare-list').html(sb);

            if (data.items.length > 0) {
                $('.compare-wrapper').slideDown();
                var compareWrapper = $("#ContentPlaceHolder1_divCompare");
                var elementTop = compareWrapper.offset().top;
                var elementBottom = elementTop + compareWrapper.outerHeight();
                if (elementBottom < $(window).scrollTop()) {
                    $('html, body').animate({
                        scrollTop: compareWrapper.offset().top
                    }, 1000);
                }
                                if (window.innerWidth < 992) {
                    $('.compare-button-responsive').css('display', 'flex');
                    $('.filter-button-responsive').css('display', 'none');
                }
                
            }
        });

        
    });

    $('.clear-compare').click(() => {
        Helpers.Utils.clearCookie('Compare');
        $('.compare-checkbox').prop('checked', false);
        $('.compare-wrapper').slideUp();
        $('.compare-checkbox').css('display', '');
    });

    $('.clear-compare-responsive').click(() => {
        Helpers.Utils.clearCookie('Compare');
        $('.compare-checkbox').prop('checked', false);
        $('.compare-wrapper').slideUp();
        $('.compare-checkbox').css('display', '');
        $('.compare-button-responsive').css('display', 'none');
        $('.filter-button-responsive').css('display', 'block');
    });
};

export {
    initCompare
};
